import { useQuery } from '@tanstack/react-query';
import type { ActivationStatus } from '../../extViewmodels/sdk/models';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { SUPPORT_PATHS, SUPPORT_QUERY_KEYS } from './supportQueryHelpers';

export interface ISupportUserSearchResult {
	userId: string;
	firstName: string;
	lastName: string;
	email: string;
	accountId: string;
	accountName: string;
	activationStatus: ActivationStatus;
}

/** Search support ticket users by name or email. Enabled when query is at least 2 characters. */
export function useSupportUserSearchQuery(query: string) {
	const userSession = useUserSession();
	const trimmedQuery = query.trim();

	return useQuery({
		queryKey: SUPPORT_QUERY_KEYS.tickets.userSearch(trimmedQuery),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<ISupportUserSearchResult[]>(
				SUPPORT_PATHS.tickets.userSearch(trimmedQuery),
				'GET'
			),
		enabled: trimmedQuery.length >= 2,
		staleTime: 10_000,
		meta: { toastErrorMessage: 'Failed to search users' },
	});
}
